import { tns } from 'tiny-slider'

let slider = '.featured-book-block .js-slider'

let blockLoaded = false;
let blockLoadedInterval = setInterval(function() {
  if (document.querySelector(slider)) {
    tns({
      container: slider,
      prevButton: '.featured-book-block .slider-controls .prev',
      nextButton: '.featured-book-block .slider-controls .next',
      nav: false,
      // autoplay: true,
      autoplayButtonOutput: false,
      loop: false,
      mouseDrag: true,
      items: 2,
      autoWidth: true,
      freezable: false,
      responsive: {
        0: {
          gutter: 32,
        },
        1280: {
          gutter: 51,
        },
      },
    })

    blockLoaded = true;
  }

  if (blockLoaded) {
    clearInterval(blockLoadedInterval);
  }
}, 500);



// WEBPACK FOOTER //
// ./scripts/block-featured-book.js